export type Progress = 'loading' | 'succeeded' | 'failed';

// reference: https://spdlybra.nintendo.co.jp/confluence/pages/viewpage.action?pageId=804916393#id-04.BlancoAPI%E3%82%A8%E3%83%A9%E3%83%BC%E5%BF%9C%E7%AD%94%E4%BB%95%E6%A7%98-%E3%83%95%E3%83%AD%E3%83%B3%E3%83%88%E5%81%B4%E3%81%AB%E6%8E%A8%E5%A5%A8%E3%81%97%E3%81%9F%E3%81%84%E5%AF%BE%E5%BF%9C%E6%96%B9%E9%87%9D
// also see: https://app.dd1.acbaa.mng.nintendo.net/sd_api_errors
export function checkErrorType(error: any) {
  if (error.response) {
    switch (error.response.data?.code) {
      case '1001':
      case '1002':
      case '1003':
      case '1101':
      case '1102':
      case '1201':
      case '1302':
      case '1401':
      case '1501':
      case '1502':
      case '1503':
      case '1601':
      case '1602':
      case '1603':
      case '1604':
      case '1605':
      case '1701':
      case '1702':
      case '1703':
      case '1704':
      case '1801':
      case '1901':
      case '2999':
      case '3001':
      case '3002':
      case '3003':
      case '3004':
      case '3005':
      case '3006':
      case '3007':
      case '3008':
      case '4001':
      case '4002':
      case '4101':
      case '4102':
        return 'client';
      case '1301':
      case '3990':
      case '3992':
      case '3993':
      case '3994':
      case '3995':
      case '3996':
      case '3997':
      case '3998':
      case '3999':
      case '4003': // エラーコード4003はサーバーエラー画面を出すためにサーバーエラーとする
      case '4103': // エラーコード4103はサーバーエラー画面を出すためにサーバーエラーとする
      default:
        return 'server';
    }
  } else {
    return 'unstable-network';
  }
}
